import React, { useRef, useEffect } from'react';
import * as echarts from 'echarts';

const ScoreLineChart = ({ chartData, title = '分值分布情况' }) => {
    const chartRef = useRef(null);
    const hasData = chartData && chartData.length > 0;

    useEffect(() => {
        if (!hasData) return;

        const myChart = echarts.init(chartRef.current);

        const markedPoint = chartData.find(item => item.index === true);

        const option = {
            title: {
                text: title,
                left: 'left'
            },
            tooltip: {
                trigger: 'item',
                formatter: '得分: {c}'
            },
            xAxis: {
                type: 'category',
                data: chartData.map(item => item.value),
                axisLabel: {
                    formatter: '{value}'
                }
            },
            yAxis: {
                type: 'value',
                name: '人数',
                axisLabel: {
                    formatter: '{value}k'
                }
            },
            series: [
                {
                    name: '得分分布',
                    type: 'line',
                    data: chartData.map(item => item.score),
                    showSymbol: true,
                    symbol: 'circle',
                    symbolSize: 8,
                    itemStyle: {
                        color: '#1890FF',
                        borderWidth: 0,
                    },
                    lineStyle: {
                        width: 2,
                        color: '#1890FF'
                    },
                    label: {
                        show: true,
                        position: 'top'
                    },
                    markPoint: markedPoint 
                        ? {
                              data: [
                                  {
                                      name: '我',
                                      coord: [markedPoint.value, markedPoint.score + 15],
                                      value: markedPoint.score,
                                      label: {
                                          show: true,
                                          formatter: '我',
                                          position: [5, 5],
                                          color: '#fff',
                                          fontSize: 12,
                                          fontWeight: 'bold',
                                      },
                                      itemStyle: {
                                          color: '#1890FF',
                                          borderWidth: 2,
                                          borderColor: '#40A9FF',
                                          shadowBlur: 10,
                                          shadowColor: 'rgba(0, 0, 0, 0.15)',
                                          shadowOffsetY: 5
                                      },
                                      symbolSize: 32,
                                      symbolRotate: 0,
                                      tooltip: {
                                          show: true,
                                          formatter: function(params) {
                                              return `我的得分: ${params.value}`;
                                          }
                                      }
                                  }
                              ]
                          } 
                        : { data: [] }
                }
            ]
        };

        myChart.setOption(option);

        const resizeHandler = () => myChart.resize();
        window.addEventListener('resize', resizeHandler);

        return () => {
            window.removeEventListener('resize', resizeHandler);
            myChart.dispose();
        };
    }, [chartData, hasData, title]);

    return (
        hasData && (
            <div
                ref={chartRef}
                style={{ width: '600px', height: '300px' }}
            />
        )
    );
};

export default ScoreLineChart;